import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const applyCoupon = createAsyncThunk('applyCoupon/applyCoupon', async (data) => {
    const token = localStorage.getItem('token')
    try {
        const res = await axios({
            method: 'post',
            url: process.env.REACT_APP_API_URL + `coupon_check`,
            data: {
                coupon_name: data?.coupon_name,
                planid: data?.planId

            },
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }
        })
        return res
    } catch (error) {
        return error.response
    }
})

